import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { customAxiosInstanceMutator } from './custom-axios-instance';

export interface StatementIqSettings { enabled: boolean; }
const URL = '/loan/api/v1/statementiq/settings';
export const STATEMENTIQ_SETTINGS_KEY = [URL];

const settingsResponse = (value: StatementIqSettings): StatementIqSettings => {
  if (!value || typeof value.enabled !== 'boolean') throw new Error('StatementIQ settings could not be loaded');
  return value;
};

export const getStatementIqSettings = async (signal?: AbortSignal) => settingsResponse(
  await customAxiosInstanceMutator<StatementIqSettings>({ url: URL, method: 'GET', signal })
);
export const saveStatementIqSettings = async (settings: StatementIqSettings) => settingsResponse(
  await customAxiosInstanceMutator<StatementIqSettings>({ url: URL, method: 'PUT', data: settings,
    headers: { 'Content-Type': 'application/json' } })
);
export const useStatementIqSettings = () => useQuery({
  queryKey: STATEMENTIQ_SETTINGS_KEY,
  queryFn: ({ signal }) => getStatementIqSettings(signal)
});
export const useSaveStatementIqSettings = () => {
  const client = useQueryClient();
  return useMutation({ mutationFn: saveStatementIqSettings,
    onSuccess: saved => client.setQueryData(STATEMENTIQ_SETTINGS_KEY, saved) });
};
